/* ArtsBouquet home – gentle scroll parallax for [data-par] images */
(function () {
  if (window.__abPar) return; window.__abPar = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function run() {
    ticking = false;
    var vh = window.innerHeight;
    document.querySelectorAll('[data-par]').forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1 around centre
      var k = parseFloat(el.getAttribute('data-par')) || 0.1;
      el.style.transform = 'translate3d(0,' + (p * k * 100).toFixed(1) + 'px,0)';
    });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  run();
})();

/* Hero tiles on tablets/phones/touch: clone tiles for a seamless moving strip and flip them automatically */
(function () {
  if (window.__abStrip) return; window.__abStrip = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var auto = window.matchMedia('(max-width: 991px), (hover: none)');
  function setup(root) {
    (root || document).querySelectorAll('.abh-hero .abh-tiles').forEach(function (t) {
      if (t.dataset.abStrip) return; t.dataset.abStrip = 1;
      var orig = Array.prototype.slice.call(t.querySelectorAll('.abh-flip'));
      if (!orig.length) return;
      orig.forEach(function (f, i) {
        if (i % 2) f.classList.add('abh-flip--low');
        var c = f.cloneNode(true);
        c.classList.add('abh-flip-clone'); c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        t.appendChild(c); f._clone = c;
      });
      // a tap opens the artwork directly (no "tap to flip" first) — tiles already flip on their own
      t.addEventListener('click', function (ev) { if (auto.matches) ev.stopPropagation(); }, true);
      var i = 0, timer = null, paused = false;
      function step() {
        if (paused) return;
        var f = orig[i % orig.length], on = !f.classList.contains('is-flipped');
        f.classList.toggle('is-flipped', on); f._clone.classList.toggle('is-flipped', on);
        i++;
      }
      // big screens: same automatic flip, a bit slower, paused while the mouse is over the artworks
      t.addEventListener('mouseenter', function () { if (!auto.matches) paused = true; });
      t.addEventListener('mouseleave', function () { paused = false; });
      function sync() {
        clearInterval(timer); timer = null;
        if (reduce) { orig.forEach(function (f) { f.classList.remove('is-flipped'); f._clone.classList.remove('is-flipped'); }); return; }
        timer = setInterval(step, auto.matches ? 1600 : 2500);
      }
      sync();
      if (auto.addEventListener) auto.addEventListener('change', sync);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); }); else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
